export const AuthorizedBy = [
  { value: "", label: "Select" },
  { value: "Maxim Filip", label: "Maxim Filip" },
  { value: "Oleg Paletchi", label: "Oleg Paletchi" },
];
